<template>
  <div class="stage">
    <div class="positioning animated">
      <div class="monitor">
        <figure ref="back" class="back"></figure>
        <figure ref="front" class="front" v-bind="$attrs">
          <slot></slot>
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
import {useResizeObserver} from '@vueuse/core'

export default {
  name: "AnimatedTransform3d",
  inheritAttrs: false,
  methods: {
    setBackDimensions() {
      if (this.$refs.front !== undefined) {
        const dim = this.$refs.front.getBoundingClientRect()
        this.$refs.back.style.width = `${dim.width - 20}px`
        this.$refs.back.style.height = `${dim.height - 3}px`
      }
    },
  },
  mounted() {
    setTimeout(() => useResizeObserver(this.$refs.front, () => {
      this.setBackDimensions()
    }), 500)
  }
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 892px) {
  .stage {
    margin-left: 2rem;
  }
}

.stage {
  perspective: 1600px;
  perspective-origin: 50% 100px;
  margin-top: 2rem;

  .positioning {
    transform-style: preserve-3d;

    &.animated {
      animation: back-and-forth 8s ease-in-out infinite;
    }

    .monitor {
      transform-style: preserve-3d;

      .front {
        background: white;
        padding: 2rem;
        transform: translateZ(4em);
      }

      .back {
        background: #efefef;
        transform: translateZ(-4em) rotateY(180deg);
      }

    }
  }
}

.monitor figure, .monitor span {
  //display: block;
  position: absolute;
  //opacity: 1;
}

@media screen and (min-width: 1024px) {
  .stage {
    margin-top: 50px;
  }
}

@media screen and (min-width: 1280px) {
  .stage {
    margin-top: 90px;

    .positioning {
      &.animated {
        animation: back-and-forth 8s ease-in-out infinite;
      }
    }
  }
}

@keyframes back-and-forth {
  0%, 30% {
    transform: rotateY(0) rotateX(0);
  }
  35%, 45% {
    transform: rotateY(20deg) rotateX(8deg);
  }
  55%, 100% {
    transform: rotateY(0) rotateX(0);
  }
}
</style>
